import React from 'react'
import classnames from 'classnames'
import Presenter from '../../../system/ping/presenter.js'
import Request from '../../../system/ping/helper/request.props.js'
import './style.css'
import windowStop from '../../../utils/windowStop.js';
import Lottie from 'react-lottie';
import * as animationInternetError from 'component/animation/internet_error.json'
import * as animationNoInternet from 'component/animation/no_internet.json'
import { css } from 'glamor'

// const PING_INTERVAL = 3600000

const PING_INTERVAL = 60000 // 60 second
const CHECK_CONNECTION_INTERVAL = 5000 // 5 second

const optionInternetError = {
  loop: true,
  autoplay: true, 
  animationData: animationInternetError,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
};

const optionNoInternet = {
  loop: true,
  autoplay: true, 
  animationData: animationNoInternet,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice'
  }
};

let backdrop = css({
  background: 'rgba(0, 0, 0, 0.65)',
  zIndex: '9999999',
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  position: 'fixed',
})
let box = css({
  display: 'flex',
  position: 'fixed',
  background: 'white',
  top: '20%',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  borderRadius: '8px',
})

let btnStyle = css({
  marginTop: '1rem',
  marginBottom: '3rem',
  borderRadius: '4px',
})

export default class OnlineDetector extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      online                : true,
      first_load            : true,
      server_error          : false,
      interactive_info      : true,
    }

    this.ping        = this.ping.bind(this)
    this.pingSuccess = this.pingSuccess.bind(this)
    this.pingFailed  = this.pingFailed.bind(this)
    this.isPingProccessing = false
  }

  ping() {
    if(this.isPingProccessing) return      

    this.isPingProccessing = true
    Presenter.PingToServer(
      Request.PingToServer(this.pingSuccess, this.pingFailed)
    )
  }

  pingSuccess(params, response) {
    this.isPingProccessing = false
    this.setState({
      server_error: false,
    })
  }

  pingFailed() {
    this.isPingProccessing = false
    this.setState({
      server_error: true,
      first_load: false,
    })
  }

  execute() {
    return new Promise(resolve => {
      setTimeout(() => {
        const {onLine} = window.navigator  

        if(onLine) {
          this.ping()

        } else {
          // not show message if page first load
          this.setState({first_load: false})
        }

        this.setState({online: onLine})
      }, 2000);
    });
  }

  async asyncCall() {
    await this.execute();
  }

  executeCheckConnection() {
    return new Promise(resolve => {
      setTimeout(() => {
        const {onLine} = window.navigator  
        
        if(!onLine) {
          if(this.state.online) {
            this.setState({
              online: false,
              first_load: false
            })
          }
        }else {
          this.setState({online: onLine})
        }
      }, 2000);
    });
  }

  async checkConnection() {
    await this.executeCheckConnection();
  }

  renderInteractiveError() {
    return(
      <div {...backdrop}>
        <div {...box} className="col-sm-6 offset-sm-3">  
          <Lottie 
            options={optionInternetError}
            height={250}
            width={250}
          />
          <h3 className="text-center">No response from API server.</h3>
          <p className="text-center">server error occurred.</p>
          <button {...btnStyle} onClick={()=>this.closeInteractive()} className="btn btn-primary">Okay, please show smaller message</button>
        </div>
      </div>
    )
  }

  renderInteractiveNoInternet() {
    return(
      <div {...backdrop}>
        <div {...box} className="col-sm-6 offset-sm-3">  
          <Lottie 
            options={optionNoInternet}
            height={250}
            width={250}
          />
          <h3 className="text-center">You are not connected to the internet.</h3>
          <p className="text-center">please check your internet connection.</p>
          <button {...btnStyle} onClick={()=>this.closeInteractive()} className="btn btn-primary">Okay, please show smaller message</button>
        </div>
      </div>
    )
  }

  closeInteractive = () => {
    this.setState({
      interactive_info: false
    })
  }

  componentDidMount() {
    this.timer = setInterval(() => {
      this.asyncCall();
    }, PING_INTERVAL);

    this.timerConnection = setInterval(() => {
      this.checkConnection()
    }, CHECK_CONNECTION_INTERVAL)
  }

  componentWillUnmount() {
    clearTimeout(this.timer)
    clearTimeout(this.timerConnection)
    windowStop()
  }

  renderInfo() {
    const {online, server_error, first_load} = this.state

    if(online) {
      if(server_error) {
        return (
          this.state.interactive_info 
          ? 
            this.renderInteractiveError()
          : 
          <div className={classnames("internet-info text-ofline",{"first-load" : first_load})}>
            <span>No response from API server, please try again.</span>
          </div>
        )
      } else {      
        return (
          <div className={classnames("internet-info text-online hideMe",{"first-load" : first_load})}>
            <span>You're back on.</span>
          </div>
        )
      }
    } else {
      return (
        this.state.interactive_info 
          ? 
            this.renderInteractiveNoInternet() 
          : 
          <div className={classnames("internet-info text-ofline",{"first-load" : first_load})}>
            <span>You are not connected to the internet.</span>
          </div>
      )
    }
  }

  render() {
    return (
      this.renderInfo()
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/views/components/OnlineDetector/OnlineDetector.js